import React, { useState } from "react";
import SearchableDropdown from "./SearchableDropdown";
import { useProductMaster } from "../../Pages/Inventory/Hooks/useProductMaster";

const ProductCategoryFilter = ({ onProductSelect }) => {
  const [category, setCategory] = useState(null);
  const [make, setMake] = useState(null);
  const { getAllMakes, fetchCategories, fetchProducts } = useProductMaster();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row justify-between gap-4">
        {/* Category Dropdown */}
        <div className="w-1/2">
          <SearchableDropdown
            fetchFunction={fetchCategories}
            onSelect={setCategory}
            value={category}
            labelKey="name"
            placeholder="Select Category"
            includeAllOption={true}
            allOptionLabel="No Category"
          />
        </div>
        {/* Make Dropdown */}
        <div className="w-1/2">
          <SearchableDropdown
            fetchFunction={(params) =>
              getAllMakes({ ...params, category: category?.id })
            }
            onSelect={setMake}
            value={make}
            labelKey="make"
            placeholder="Select Make"
            disabled={!category}
          />
        </div>
      </div>

      {/* Product Dropdown (Filtered by Category) */}
      <div className="w-full">
        <div>
          <SearchableDropdown
            fetchFunction={(params) =>
              fetchProducts({
                ...params,
                category: category?.id,
                make: make?.make,
              })
            }
            onSelect={onProductSelect}
            labelKey="product_name"
            subLabelKey="specification"
            showSubLabel={true}
            placeholder="Select Product"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductCategoryFilter;
